export var MODE;
(function (MODE) {
    MODE["DARK"] = "dark";
    MODE["LIGHT"] = "light";
})(MODE || (MODE = {}));
export var defaultConfig = {
    autoModeCookieName: 'autoMode',
    cookieOptions: { sameSite: 'lax' },
    darkModeCookieName: 'darkMode',
    defaultMode: MODE.LIGHT,
};
//# sourceMappingURL=config.js.map